/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";

import type { FC, SVGAttributes } from "react";

type Props = SVGAttributes<SVGElement>;

// FcWithoutChildren にしたいが props の定義が react に沿いきってないみたいでエラーが出るため FC を利用
export const ArrowIcon: FC<Props> = (props) => {
  return (
    <svg viewBox="0 0 12 8" fill="none" {...props}>
      <path
        d="M11 6.5L6 1.5L1 6.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
